module.exports = __webpack_public_path__ + "static/media/php.5eadedcc.png";